import React from 'react';
import { faqSections } from '../../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="bg-cream py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center reveal">
          <div className="gold-divider mb-4">
            <span className="chapter-badge text-gold uppercase">Frequently Asked Questions</span>
          </div>
          <h2 className="font-serif-display text-navy text-4xl md:text-5xl leading-[1.1] font-medium">
            Questions? We&rsquo;re here to help.
          </h2>
          <p className="mt-4 font-serif-editorial text-navy/70 text-lg md:text-xl">
            A few gentle answers, before you decide to activate.
          </p>
        </div>

        <div className="mt-14 space-y-12 reveal">
          {faqSections.map((section, si) => (
            <div key={section.title}>
              <div className="flex items-center gap-4 mb-4">
                <span className="chapter-badge text-gold uppercase">
                  {String(si + 1).padStart(2, '0')} &middot; {section.title}
                </span>
                <span className="flex-1 h-px bg-gold/40" />
              </div>

              <Accordion type="single" collapsible className="w-full">
                {section.items.map((item, i) => (
                  <AccordionItem
                    key={`${si}-${i}`}
                    value={`item-${si}-${i}`}
                    className="border-b border-divider"
                  >
                    <AccordionTrigger className="font-serif-display text-navy text-lg md:text-xl text-left py-5 hover:no-underline">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="font-serif-editorial text-navy/80 text-lg leading-relaxed pb-6">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center reveal">
          <p className="font-serif-editorial italic text-navy/70 text-lg">
            Still have a question? Speak with our Experience Team &mdash; always calm, always at hand.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
